export const TYPES = {
    full: "full",
    disabledDirections: "disabledDirections",
    permanentDeliveryMethods: "permanentDeliveryMethods",
};

export class CalculatorSettings {
    constructor() {
        this.disableDirections = false;
        this.disableCountryOut = false;
        this.hideDeliveryMethods = false;
        this.showSpecialOffer = false;
    }
}
